import React from "react";
import { createRoot } from 'react-dom/client';
import { flushSync } from 'react-dom';

export async function renderContentToHtmlString(content: React.ReactNode) {
	const div = document.createElement('div');
	const root = createRoot(div);

	if (content) {
		flushSync(() => {
			root.render(content);
		});
		const html = div.innerHTML;
		div.innerText = '';
		return Promise.resolve(html);

		// return new Promise((resolve) => {
		// 	setTimeout(() => {
		// 		resolve(div.innerHTML);
		// 	}, 1);
		// });
	}

	return Promise.resolve('');
}
